var map = {
	"./about-us.md": 3497,
	"./account-opening.md": 2981,
	"./deposit-banking.md": 4681,
	"./investment-banking.md": 9727,
	"./investment-services.md": 3741,
	"./online-banking.md": 8378,
	"./online-security.md": 2560,
	"./personal-banking.md": 9196,
	"./private-banking.md": 5236,
	"./terms-and-conditions.md": 6737
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5060;